import AlertList from "../components/alertList/alertList";
import {UserRoles} from "../../helpers/userRoles";

export enum alertsRoutingAddress {
    list = "/alerts/list"
}

export const alertsRoutes = [
    {
        path: alertsRoutingAddress.list,
        component: AlertList,
        roles: [UserRoles.alertsViewAndModification]
    }
];
